import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconBack = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.223042 7.54628L6.45322 13.7763C6.59732 13.9206 6.78968 14 6.99478 14C7.19989 14 7.39224 13.9206 7.53634 13.7763L7.99515 13.3176C8.2937 13.0188 8.2937 12.533 7.99515 12.2345L2.76351 7.0029L8.00095 1.76547C8.14505 1.62126 8.22461 1.42901 8.22461 1.22402C8.22461 1.0188 8.14505 0.826562 8.00095 0.682239L7.54214 0.223657C7.39793 0.0794469 7.20569 8.90768e-08 7.00058 1.07008e-07C6.79548 1.24938e-07 6.60312 0.0794469 6.45903 0.223657L0.223042 6.45941C0.0786041 6.60408 -0.000728283 6.79723 -0.000273363 7.00256C-0.000728247 7.20869 0.0786041 7.40173 0.223042 7.54628Z" fill={color}/>
        </svg>
    </div>
);

export default IconBack;
